"use strict";

_BannerFlowApp.directive("bsButtonsRadio", function ($timeout) {
    return {
        restrict: "A",
        require: "?ngModel",
        compile: function compile(tElement, tAttrs, transclude) {
            tElement.attr("data-toggle", "buttons-radio");

            // Delegate to children ngModel
            if (!tAttrs.ngModel) {
                tElement.find("a, button").each(function (k, v) {
                    $(v).attr("bs-button", "");
                });
            }

            return function postLink(scope, iElement, iAttrs, controller) {
                // If we have a controller (i.e. ngModelController) then wire it up
                if (controller) {
                    $timeout(
                        function () {
                            iElement
                                .find("[value]")
                                .button()
                                .filter('[value="' + controller.$modelValue + '"]')
                                .addClass("active");
                        },
                        0,
                        false
                    );

                    iElement.on("click.button.data-api", function (ev) {
                        scope.$apply(function () {
                            controller.$setViewValue($(ev.target).closest("button").attr("value"));
                        });
                    });

                    // Watch model for changes
                    scope.$watch(iAttrs.ngModel, function (newValue, oldValue) {
                        if (newValue !== oldValue) {
                            var $btn = iElement.find('[value="' + scope.$eval(iAttrs.ngModel) + '"]');
                            if ($btn.length) {
                                $btn.button("toggle");
                                // $.fn.button.Constructor.prototype.toggle.call($btn.data('button'));
                            }
                        }
                    });
                }
            };
        }
    };
});
